"use client"
 
import { LeavePoliciesMergedPage } from "../../../modules/leave-management/leave-policies-merged"

interface LeavePoliciesProps {
  sidebarOpen?: boolean
}

export default function LeavePolicies({sidebarOpen }: LeavePoliciesProps) {
  return <LeavePoliciesMergedPage />
}

